export class Incoterm {
    public id:number|null;
    public name:string;
    public description:string;

    constructor(data:IncotermData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.name = "";
            this.description = "";
        }
        else
        {
            this.id = data.id;
            this.name = data.name;
            this.description = data.description;
        }
    }

    serializeData():IncotermData {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
        }
    }
}

export type IncotermData = {
    id:number|null;
    name:string;
    description:string;
}